import { useEffect, useState } from "react";
import { ShieldAlert, CheckCircle2 } from "lucide-react";
import { api } from "@/lib/api";

// R14: the sidebar note used to be the fixed string "Providers off = manual fallback active", which stayed on screen
// even when Voice and Meta were enabled. It now states the real per-provider state from GET /comms/provider-state.
export function describeProviderState(providers) {
  const list = Array.isArray(providers) ? providers : null;
  if (!list) return { tone: "unknown", text: "Provider status unavailable" };
  if (list.length === 0) return { tone: "unknown", text: "No live providers configured" };
  const off = list.filter((p) => !p.enabled).map((p) => p.label);
  if (off.length === 0) return { tone: "ok", text: "All configured providers are live" };
  const on = list.length - off.length;
  return {
    tone: "degraded",
    text: `${on} live · Off (manual fallback active): ${off.join(", ")}`,
  };
}

export const ProviderStateNote = () => {
  const [state, setState] = useState(null);
  useEffect(() => {
    let alive = true;
    api.get("/comms/provider-state")
      .then((r) => { if (alive) setState(describeProviderState(r.data?.providers)); })
      .catch(() => { if (alive) setState(describeProviderState(null)); });
    return () => { alive = false; };
  }, []);
  const s = state || { tone: "unknown", text: "Checking provider status…" };
  return (
    <div className="p-3 border-t text-[11px] text-muted-foreground" data-testid="provider-state-note">
      <div className="flex items-start gap-1.5">
        {s.tone === "ok"
          ? <CheckCircle2 className="h-3 w-3 mt-0.5 shrink-0 text-[hsl(var(--success))]" />
          : <ShieldAlert className="h-3 w-3 mt-0.5 shrink-0 text-[hsl(var(--degraded))]" />}
        <span data-testid="provider-state-text">{s.text}</span>
      </div>
    </div>
  );
};

export default ProviderStateNote;
